<template>
    <v-dialog v-model="dialog" style="width: 100%;">
        <v-card>
            <div id="jobCode" class="pdf-content">
                <div
                    style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
                    <v-col cols="3">
                        <v-img src="@/assets/logo_delta.jpg" contain height="90" />
                    </v-col>
                    <v-col cols="9" class="text-right">
                        <h2 class="mb-0">Job: {{ job.code }}</h2>
                    </v-col>
                </div>

                <v-card outlined>
                    <v-card-title class="d-flex justify-space-between">
                        <span><strong>Cliente: </strong> {{ job?.clienteNome }}</span>
                        <span><strong>Inscr. Estadual: </strong> {{ job.cliente[0]?.inscricaoEstadual }}</span>
                    </v-card-title>

                    <v-card-text>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <strong>Endereço:</strong> {{ job.cliente[0]?.entregaEndereco }}, {{ job.cliente[0]?.entregaNumero }}
                            </v-col>
                            <v-col cols="12" sm="6">
                                <strong>Fone:</strong> {{ '' }}
                            </v-col>
                            <v-col cols="12" sm="6">
                                <strong>Município:</strong> {{ job.cliente[0]?.entregaCidadeNome }}
                            </v-col>
                            <v-col cols="12" sm="6">
                                <strong>Fone:</strong>
                            </v-col>
                            <v-col cols="12">
                                <strong>CNPJ:</strong> {{ job.cliente[0]?.cnpj }}
                            </v-col>
                        </v-row>

                        <v-divider class="my-4"></v-divider>

                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <strong>Contato Coml.:</strong> {{ job.cliente[0]?.nomeFantasia }}
                            </v-col>
                            <v-col cols="12" sm="6">
                                <strong>Data Abertura:</strong> {{ new Date(job.dataAbertura).toLocaleDateString() }}
                            </v-col>
                            <v-col cols="12" sm="6">
                                <strong>e-mail Coml.:</strong> {{ !job.revisoes ? job.contatoComercial[0].email : job.revisoes.contatoComercial[0].email }}
                            </v-col>
                            <v-col cols="12" sm="6">
                                <strong>Data Encerramento:</strong> {{ job.dataEncerramento ? new Date(job.dataEncerramento).toLocaleDateString() : 'Não Informado' }}
                            </v-col>
                            <v-col cols="12" sm="6">
                                <strong>Contato Tec.:</strong> {{ !job.revisoes ? job.contatoTecnico[0].telefone : job.revisoes.contatoTecnico[0].telefone }}
                            </v-col>
                            <v-col cols="12" sm="6">
                                <strong>Pedido Cliente:</strong> {{ !job.revisoes ? job.pedidoCompra : job.revisoes.pedidoCompra }}
                            </v-col>
                            <v-col cols="12" sm="6">
                                <strong>e-mail Tec.:</strong> {{ !job.revisoes ? job.contatoTecnico[0].email : job.revisoes.contatoTecnico[0].email }}
                            </v-col>
                            <v-col cols="12" sm="6">
                                <strong>Responsável:</strong> {{ !job.revisoes ? job?.colaborador[0]?.name : job.revisoes?.colaborador[0]?.name }}
                            </v-col>
                        </v-row>

                        <v-divider class="my-4"></v-divider>

                        <v-row dense>
                            <!-- <v-col cols="12" sm="6">
                                <strong>Proposta:</strong> 
                            </v-col> -->
                            <v-col cols="12" sm="6">
                                <strong>Vendedor:</strong> {{ !job.revisoes ? job.vendedorNome || "Não Informado" : job.revisoes.vendedorNome || "Não Informado" }}
                            </v-col>
                            <v-col cols="12">
                                <strong>Equipamento:</strong> PEÇAS SOBRESSALENTES
                            </v-col>
                            <v-col cols="12">
                                <strong>Cond. Pagto.:</strong> {{ !job.revisoes ? job.condicaoDePagamento : job.revisoes.condicaoDePagamento }}
                            </v-col>
                        </v-row>

                        <v-alert dense type="info" outlined class="mt-4">
                            NÃO HÁ RESTRIÇÃO INFORMADA SOBRE EMISSÃO DE BOLETO
                        </v-alert>

                        <v-row dense class="mt-4">
                            <v-col cols="6" offset="6">
                                <div><strong>Valor ISS:</strong> R$ 0,00</div>
                                <div><strong>Valor IPI:</strong> R$ 0,00</div>
                                <div><strong>Valor ICMS:</strong> R$ 252,00</div>
                                <div><strong>Preço s/ IPI c/ ICMS:</strong> R$ 2.100,00</div>
                                <div><strong>Preço c/ IPI c/ ICMS:</strong> R$ 2.100,00</div>
                                <div><strong>Multas Contratuais:</strong> R$ 0,00</div>
                                <div><strong>Valor Líquido:</strong> <strong>R$ 1.848,00</strong></div>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-divider class="my-4"></v-divider>

                    <v-row>
                        <v-col cols="12">
                            <strong>Descrição:</strong> {{ !job.revisoes ? job.description : job.revisoes.description }}
                            <!-- <div class="mt-2"><strong>Nº JOB:</strong> 17-02712 / 23-13385</div> -->
                        </v-col>
                    </v-row>

                    <v-simple-table class="mt-4 w-100">
                        <thead>
                            <tr>
                                <!-- <th style="width: 50px;">#</th> -->
                                <th>Descrição do Item</th>
                                <th style="width: 50px;">Quant.</th>
                                <th style="width: 50px;">Valor Total</th>
                                <th style="width: 50px;">IPI</th>
                                <th style="width: 50px;">ISS</th>
                                <th style="width: 50px;">ICMS</th>
                                <th style="width: 50px;">Base ICMS/IPI</th>
                                <th style="width: 50px;">Class. Fiscal</th>
                            </tr>
                        </thead>
                        <tbody v-if="!job.revisoes">
                            <tr v-for="jobItem in job.jobItens" :key="jobItem._id">
                                <!-- <td style="width: 50px;">{{ jobItem.sequencia || jobItem.codigo }}</td> -->
                                <td style="font-size: 15px;">
                                    {{ jobItem.descricao }}
                                </td>
                                <td style="width: 50px;">{{ jobItem.quantidade }}</td>
                                <td style="width: 50px;">{{ jobItem.precoTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</td>
                                <td style="width: 50px;">{{ jobItem.IPI || 0 }}</td>
                                <td style="width: 50px;">{{ jobItem.ISS || 0 }}</td>
                                <td style="width: 50px;">{{ jobItem.ICMS || 0 }}</td>
                                <td style="width: 50px;">{{ jobItem.precoVenda_sIPI_sICMS }}</td>
                                <td style="width: 50px;">{{ jobItem.classificacaoFiscalNCM }}</td>
                            </tr>
                        </tbody>

                        <tbody v-else>
                            <tr v-for="jobItem in job.revisoes.jobItens" :key="jobItem._id">
                                <td style="font-size: 15px;">
                                    {{ jobItem.descricao }}
                                </td>
                                <td style="width: 50px;">{{ jobItem.quantidade }}</td>
                                <td style="width: 50px;">{{ jobItem.precoTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</td>
                                <td style="width: 50px;">{{ jobItem.IPI || 0 }}</td>
                                <td style="width: 50px;">{{ jobItem.ISS || 0 }}</td>
                                <td style="width: 50px;">{{ jobItem.ICMS || 0 }}</td>
                                <td style="width: 50px;">{{ jobItem.precoVenda_sIPI_sICMS }}</td>
                                <td style="width: 50px;">{{ jobItem.classificacaoFiscalNCM }}</td>
                            </tr>
                        </tbody>

                    </v-simple-table>

                    <v-row justify="end" class="mt-2">
                        <v-col cols="4">
                            <div><strong>Entrega:</strong> {{ new Date(job.dataEntregaContratual).toLocaleDateString() }}</div>
                            <div><strong>Total:</strong> {{ job.valorJob.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</div>
                        </v-col>
                    </v-row>

                    <v-simple-table class="mt-4" dense>
                        <thead>
                            <tr>
                                <th>Vencimento</th>
                                <th>Descrição</th>
                                <th>Valor Parcela</th>
                                <th>Liquidação</th>
                                <th>Valor Pago</th>
                                <th>Ult. Alteração</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>28/02/2025</td>
                                <td>100% A 30 DDL</td>
                                <td>2.100,00</td>
                                <td></td>
                                <td>0,00</td>
                                <td>26/12/2024</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card>
            </div>
            
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" @click="$emit('cancel')">Cancelar</v-btn>   
                <v-btn color="primary" @click="exportPdf">Gerar PDF</v-btn>    
            </v-card-actions>

        </v-card>
    </v-dialog>
</template>

<script>
import html2pdf from 'html2pdf.js'

export default {
    name: 'JobCodeView',
    props: ['isOpen', 'job'],
    data() {
        return {
            dialog: false
        }
    },
    watch: {
        isOpen(value){
            console.log('JOB >>> ', this.job)
            this.dialog = value
        }
    },

    methods: {
        exportPdf() {
            const elemento = document.getElementById("jobCode");
            html2pdf()
            .set({
                margin: 10,
                filename: 'Relatorio-Job-145.pdf',
                html2canvas: { scale: 2 },
                jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
            })
            .from(elemento)
            .save();
        },
    }
}
</script>

<style scoped>
.pdf-content {
  font-family: 'Arial', sans-serif;
  padding: 20px;
}

.avoid-break {
  page-break-inside: avoid;
  break-inside: avoid;
}

tr {
  page-break-inside: avoid !important;
  break-inside: avoid !important;
  font-size: 20px;
}
</style>